import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/(authorization)/layout.tsx");
